export function formatApiError(error) {
  if (!error) return "Bilinmeyen hata";

  const data = error.response?.data;
  if (typeof data === "string" && data.trim()) return data;
  if (data?.message) return String(data.message);
  if (data?.Message) return String(data.Message);
  if (Array.isArray(data?.errors)) return data.errors.map(String).join(" | ");
  if (data?.data && typeof data.data === "string") return data.data;

  if (data && typeof data === "object") {
    try {
      const compact = JSON.stringify(data);
      if (compact.length <= 500) return compact;
      return `${compact.slice(0, 497)}...`;
    } catch {
      /* ignore */
    }
  }

  if (error.message) return error.message;
  return "Bilinmeyen hata";
}
